<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
  mixins: [Api, Sabit],
  props: ["UstDonemId", "DonemId", "Sorgulama", "BirimId"],
  components: {
    Loader,
  },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: {},
      DonemAdi: "",
      DataUpdate: "",
      loading: true,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },
  watch: {
    DonemId() {
      this.Get();
    },
    BirimId() {
      this.Get();
    },
  },
  methods: {
    Get() {
      let Filter =
        "&DonemId=" +
        this.DonemId +
        "&UstDonemId=" +
        this.UstDonemId +
        "&Birimid=" +
        (this.BirimId == null ? "" : this.BirimId);
      this.ActionsFilterGet({
        Service: "StrRaporlama/GetBirimHedefTutturmaOranlariTablosu",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
      });
    },
    Fark(Data) {
      var Fark = 0;
      if (Data) {
        Fark = Data.Universitehedefi - Data.Birimbazlihedeftoplam;
      }
      return Fark;
    },
    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.veriGiris;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
    ExcelExport2(table, name) {
      if (!table.nodeType) table = this.$refs.birimgostergetablosu;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },

  computed: {},
  created() {
    this.Get();
  },
};
</script>
<template>
  <Loader>
<div class="container-fluid p-0 m-0">
  <div class="text-sm-end mb-3">
    <button
      type="button"
      class="btn btn-success btn-rounded"
      @click="ExcelExport('birimhedeftutturmaoranlaritablosu', 'birimhedeftutturmaoranlaritablosu')"
    >
      <i class="mdi mdi-file-export-outline me-1"></i>
      Excel'e Aktar
    </button>
  </div>

  <div ref="veriGiris" class="table-responsive w-100">
    <table class="table table-borderless w-100 mb-0" style="text-align: center;">
      <tr>
        <td colspan="4" class="h5 text-center" style="font-family: Arial;">
          Birim Hedef Tutturma Oranları Tablosu <br />
        </td>
      </tr>
    </table>

    <br />
    <div class="card w-100">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered w-100" style="border-collapse: collapse; table-layout: fixed;">
            <thead>
              <tr
                style="background-color: #2A3042; color:white; height: 50px; text-align: center;"
              >
                <th class="col-md-2">Birimler</th>
                <th class="col-md-2">Girilen Hedef Sayısı</th>
                <th class="col-md-2">Hedef Sapma Sayısı(0-50)</th>
                <th class="col-md-2">Hedef Sapma Sayısı(51 ve üzeri)</th>
                <th class="col-md-2">Toplam Yüzde</th>
                <th class="col-md-1">Hedef</th>
                <th class="col-md-1">Diğer</th>
              </tr>
            </thead>
            <tbody v-for="(Data, index) in TableData" :key="index">
              <tr style="text-align: center;">
                <td>{{ Data.Birimadi }}</td>
                <td>{{ Data.Girilenhedef }}</td>
                <td :style="{ backgroundColor: '#00a000', color: 'wheat' }">
                  {{ Data.Detay.length > 0 ? Data.Soa : '0' }}
                </td>
                <td :style="{ backgroundColor: '#ff4040', color: 'wheat' }">
                  {{ Data.Detay.length > 0 ? Data.Soy : '0' }}
                </td>
                <td>
                  {{ Data.TopYuzde !== 'NaN' ? parseFloat(Data.TopYuzde).toFixed(2) : 0 }}
                </td>
                <td>
                  <div class="mt-2">
                    <i
                      v-b-modal.HedefTutturmaData
                      @click="DataUpdate = Data"
                      class="fas fa-plus"
                    ></i>
                  </div>
                </td>
                <td>
                  <div class="mt-2">
                    <i
                      v-b-modal.GerceklesmeData
                      @click="DataUpdate = Data"
                      class="fas fa-plus"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


    <b-modal
      id="HedefTutturmaData"
      size="lg"
      title="Detay"
      title-class="font-18"
      hide-footer
    >
      <br />

      <div class="card">
        <div class="card-body">
          <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport2('birimgostergetablosu', 'birimgostergetablosu')
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
          </div>
          <div class="col-md-12" ref="birimgostergetablosu">
            <div class="table-responsive">
              <table
                class="table table-borderless mb-0"
                style="border-collapse: collapse; width: 100%"
              >
                <tr>
                  <td
                    colspan="4"
                    class="h5"
                    style="text-align: center; font-family: Arial; display: block;"
                  >
                    BİRİM GÖSTERGE TABLOSU <br />
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="4"
                    class="h5"
                    style="text-align: center; font-family: Arial; display: block;"
                  >
                    {{ DataUpdate.Birimadi }} <br />
                  </td>
                </tr>
              </table>

              <table class="table-bordered">
                <thead>
                  <tr
                    style="background-color: #2A3042; border-color:white; border-style: solid; color:white; height: 50px; text-align: center; "
                    rowspan="4"
                  >
                    <th class="col-md-3">Gösterge</th>
                    <th class="col-md-3">Hedeflenen Hedef</th>
                    <th class="col-md-3">Gerçekleşen Hedef</th>
                    <th class="col-md-3">Oran</th>
                  </tr>
                </thead>
                <tbody
                  v-for="(SubData, index) in DataUpdate.Detay"
                  :key="index"
                  rowspan="4"
                >
                  <tr style="text-align: center; border:wheat">
                    <td class="col-md-3">{{ SubData.Gos }}</td>
                    <td class="col-md-3">{{ SubData.Hh }}</td>
                    <td class="col-md-3">{{ SubData.Gh }}</td>

                    <td
                      class="col-md-3"
                      v-if="
                        (SubData.So < 50 || SubData.So > 150) &&
                          !(SubData.Hh == 0 && SubData.Gh == 0)
                      "
                      style="background-color:#ff4040;"
                    >
                      <span style="color:wheat">{{ SubData.So }}</span>
                    </td>
                    <td
                      class="col-md-3"
                      v-if="SubData.Hh == 0 && SubData.Gh == 0"
                      style="background-color:grey;"
                    >
                      <span style="color:white">{{ SubData.So }}</span>
                    </td>
                    <td
                      class="col-md-3"
                      v-if="
                        !(SubData.So < 50 || SubData.So > 150) &&
                          !(SubData.Hh == 0 && SubData.Gh == 0)
                      "
                      style="background-color:#00a000;;"
                    >
                      <span style="color:wheat">{{ SubData.So }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="GerceklesmeData"
      size="lg"
      title="Detay"
      title-class="font-18"
      hide-footer
    >
      <br />

      <div class="card">
        <div class="card-body">
          <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport2('birimgostergetablosu', 'birimgostergetablosu')
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
          </div>
          <div class="col-md-12" ref="birimgostergetablosu">
            <div class="table-responsive">
              <table
                class="table table-borderless mb-0"
                style="border-collapse: collapse; width: 100%"
              >
                <tr>
                  <td
                    colspan="4"
                    class="h5"
                    style="text-align: center; font-family: Arial; display: block;"
                  >
                    BİRİM HEDEF TANIMLANMAYAN GÖSTERGE TABLOSU <br />
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="4"
                    class="h5"
                    style="text-align: center; font-family: Arial; display: block;"
                  >
                    {{ DataUpdate.Birimadi }} <br />
                  </td>
                </tr>
              </table>

              <table class="table-bordered">
                <thead>
                  <tr
                    style="background-color: #2A3042; border-color:white; border-style: solid; color:white; height: 50px; text-align: center; "
                    rowspan="4"
                  >
                    <th class="col-md-3">Gösterge</th>
                    <th class="col-md-3">Gerçekleşme</th>
                  </tr>
                </thead>
                <tbody
                  v-for="(SubData, index) in DataUpdate.DetaySadeceGerceklesme"
                  :key="index"
                  rowspan="4"
                >
                  <tr style="text-align: center; border:wheat">
                    <td class="col-md-3">{{ SubData.Gos }}</td>
                    <td class="col-md-3">{{ SubData.Gh }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
<style>
td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
